import React from 'react'

import clsx from 'clsx'

import {
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Typography,
  makeStyles,
  Tooltip,
  IconButton,
} from '@material-ui/core'

import { Edit } from '@material-ui/icons'

import helpers from 'helpers'

import styles from './styles'

const useStyles = makeStyles(styles)

const CustomerStaticForm = ({
  customer,
  formatFields = true,
  showTitles = true,
  showEdit = true,
  onClickEdit,
}) => {
  const classes = useStyles()

  const isCompany = React.useMemo(
    () => helpers.people.isCompany(customer.kind),
    [customer.kind],
  )

  const fields = React.useMemo(() => {
    const commonFields = {
      kind: customer.kind,
      name: customer.name || '',
      email: customer.email,
      companyName: customer.companyName || '',
      tradeName: customer.tradeName || '',
      address: {
        ...customer.address,
        complement: customer.address.complement || '',
      },
    }

    if (formatFields) {
      return {
        ...commonFields,
        cpf: helpers.people.formatCpf(customer.cpf || ''),
        cnpj: helpers.people.formatCnpj(customer.cnpj || ''),
        phone: helpers.people.parsePhoneApi(customer.contact || ''),
        address: {
          ...commonFields.address,
          postalCode: helpers.people.formatCep(
            customer.address.postalCode || '',
          ),
        },
      }
    }

    return {
      ...commonFields,
      cpf: customer.cpf || '',
      cnpj: customer.cnpj || '',
      phone: `(${customer.contact.areaCode}) ${customer.contact.number}`,
      address: {
        ...commonFields.address,
        postalCode: customer.address.postalCode || '',
      },
    }
  }, [customer, formatFields])

  return (
    <div>
      {showTitles && (
        <div className={classes.titleBox}>
          <Typography variant="h4" color="textSecondary">
            Seus dados
          </Typography>

          {showEdit && (
            <Tooltip title="Editar">
              <IconButton onClick={onClickEdit}>
                <Edit />
              </IconButton>
            </Tooltip>
          )}
        </div>
      )}

      <RadioGroup
        value={fields.kind}
        className={classes.radioGroup}
        disabled
        row
      >
        <FormControlLabel
          value="P"
          control={<Radio disabled />}
          label="Pessoa Física"
        />
        <FormControlLabel
          value="C"
          control={<Radio disabled />}
          label="Pessoa Jurídica"
        />
      </RadioGroup>

      <div className={classes.fields}>
        <TextField
          label="Nome"
          name="name"
          value={fields.name}
          disabled
          fullWidth
        />

        <TextField
          label="CPF"
          name="cpf"
          value={fields.cpf}
          disabled
          fullWidth
        />
      </div>

      {isCompany && (
        <>
          <div className={classes.field}>
            <TextField
              label="Razão social"
              value={fields.companyName}
              disabled
              fullWidth
            />
          </div>

          <div className={classes.fields}>
            <TextField
              label="Nome fantasia"
              value={fields.tradeName}
              disabled
              fullWidth
            />
            <TextField label="CNPJ" value={fields.cnpj} disabled fullWidth />
          </div>
        </>
      )}

      <div className={classes.field}>
        <TextField
          label="Email"
          name="email"
          value={fields.email}
          disabled
          fullWidth
        />
      </div>

      <div className={classes.field}>
        <TextField
          label="Telefone"
          inputProps={{
            maxLength: 15,
          }}
          name="phone"
          value={fields.phone}
          disabled
          fullWidth
        />
      </div>

      {showTitles && (
        <div className={clsx(classes.titleBox, classes.titleBoxAddress)}>
          <Typography variant="h4" color="textSecondary">
            Endereço
          </Typography>
        </div>
      )}

      <div className={classes.fields}>
        <TextField
          label="CEP"
          value={fields.address.postalCode}
          onChange={() => {}}
          disabled
          fullWidth
        />
      </div>

      <div className={classes.fields}>
        <TextField
          label="Rua"
          value={fields.address.street}
          disabled
          fullWidth
        />
        <TextField
          label="Número"
          value={fields.address.number}
          disabled
          fullWidth
        />
        <TextField
          label="Bairro"
          value={fields.address.neighborhood}
          disabled
          fullWidth
        />
        <TextField
          label="Cidade"
          value={fields.address.city}
          disabled
          fullWidth
        />
        <TextField
          label="Estado"
          value={fields.address.state}
          disabled
          fullWidth
        />
        <TextField
          label="Complemento (opcional)"
          value={fields.address.complement}
          disabled
          fullWidth
        />
      </div>
    </div>
  )
}

export default CustomerStaticForm
